<section class="kpi-row-grid">
  <!-- Students Assessed -->
  <div class="kpi-card prominent">
    <div class="kpi-top">
      <p class="kpi-label">Students Assessed</p>
      <span class="kpi-icon-wrap prominent">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      </span>
    </div>
    <p class="kpi-value prominent">{{ kpis.assessed }}</p>
    <p class="kpi-hint">Appeared for the readiness assessment</p>
  </div>

  <!-- Average Readiness Score -->
  <div class="kpi-card prominent">
    <div class="kpi-top">
      <p class="kpi-label">Average Readiness Score</p>
      <span class="kpi-icon-wrap prominent">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m12 14 4-4"/>
          <path d="M3.34 19a10 10 0 1 1 17.32 0"/>
        </svg>
      </span>
    </div>
    <p class="kpi-value prominent">{{ kpis.averageScore }}</p>
    <p class="kpi-hint">Cohort average out of 100</p>
  </div>

  <!-- Ready Students -->
  <div class="kpi-card">
    <span class="top-accent ready"></span>
    <div class="kpi-top">
      <p class="kpi-label">Ready Students</p>
      <span class="kpi-icon-wrap ready">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"/>
          <path d="m9 12 2 2 4-4"/>
        </svg>
      </span>
    </div>
    <p class="kpi-value">{{ kpis.ready }}</p>
    <p class="kpi-hint">Score ≥ 80</p>
  </div>

  <!-- Developing Students -->
  <div class="kpi-card">
    <span class="top-accent developing"></span>
    <div class="kpi-top">
      <p class="kpi-label">Developing Students</p>
      <span class="kpi-icon-wrap developing">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/>
          <polyline points="16 7 22 7 22 13"/>
        </svg>
      </span>
    </div>
    <p class="kpi-value">{{ kpis.developing }}</p>
    <p class="kpi-hint">Score 60–79</p>
  </div>

  <!-- At Risk Students -->
  <div class="kpi-card">
    <span class="top-accent at-risk"></span>
    <div class="kpi-top">
      <p class="kpi-label">At Risk Students</p>
      <span class="kpi-icon-wrap at-risk">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
          <line x1="12" y1="9" x2="12" y2="13"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </span>
    </div>
    <p class="kpi-value">{{ kpis.atRisk }}</p>
    <p class="kpi-hint">Score &lt; 60</p>
  </div>
</section>
